import { Control, useWatch } from 'react-hook-form';
import { AutocompleteValue } from './FormAutocomplete/form-autocomplete';

export function useWatchConditions({
  control,
  showsIf,
}: {
  control?: Control<Record<string, AutocompleteValue>>;
  showsIf?: {
    name: string;
    value: AutocompleteValue | { id: (number | string)[]; label: string };
  }[];
}) {
  const showsIfValues = useWatch<Record<string, AutocompleteValue>>({
    control,
    name: showsIf?.map((field) => field.name) ?? [],
  });

  // If it doesn't depend on other fields it should be shown.
  if (!showsIf?.length) {
    return true;
  }

  const shouldShow = showsIf?.every(({ value }) =>
    showsIfValues.some((v) => {
      const expectedValue =
        typeof value === 'object' && ('id' in value || 'label' in value)
          ? value?.id || value?.label
          : value;
      const currentValue = typeof v === 'object' && 'id' in v ? v?.id : v;
      return Array.isArray(expectedValue)
        ? expectedValue.includes(currentValue)
        : expectedValue === currentValue;
    }),
  );

  return shouldShow;
}
